import SkeletonTable from "@/components/SkeletonTable";
import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { DataTable } from "./partial/DataTable";
import { columns } from "./partial/Columns";

const getListKelompokVerifikasiUkt = async (id_verukt_rekap: string) => {
  const response = await api.get(
    `/setting/verifikator-ukt/show-kelompok/${id_verukt_rekap}`,
    {
      withCredentials: true,
    },
  );
  return response.data;
};

export default function SettingVerifikatorDetailPage() {
  const [searchParams] = useSearchParams();
  const idVerUktRekap = searchParams.get("id");

  const { data, isPending } = useQuery({
    queryKey: ["listKelompokVerifikasiUkt", idVerUktRekap],
    queryFn: () => getListKelompokVerifikasiUkt(String(idVerUktRekap)),
  });

  if (isPending) return <SkeletonTable />;

  return (
    <div>
      <DataTable data={data?.data || []} columns={columns} />
    </div>
  );
}
